
import { BaseViewModel, IEntityConstructorOptions } from "./Base/BaseViewModel";
import { DataEntityBase, Models, SimpleText } from "../Services/DataService/Model";
import { ModelManager } from "./ModelManager";
import { BasicEntityWatcher } from "../Services/DataService/EntityWatcher";
import { IConstructorOptions } from "../Utilities";
import { ICorrelation } from "./Utilities";

export class SimpleTextViewModel extends BaseViewModel {

    public static get TypeName() { return Models.SimpleText; };
    public get TypedData() { return ((this.Data as unknown) as SimpleText); }


    public static Manager = new ModelManager<SimpleTextViewModel>({
        createFN:
            async (options?: IEntityConstructorOptions) => {
                var retVal = new SimpleTextViewModel(options);
                return retVal;
            },
        idFromKeyFN: (key: string) => SimpleText.CreateId(key),
        typeName: Models.SimpleText,
    });

    public get isEmpty() {
        return this.TypedData.text.length === 0;
    }

    protected CreateData(watcher: BasicEntityWatcher, options?: IConstructorOptions) {
        return SimpleText.Create(watcher, options);
    }

    private constructor(options?: IEntityConstructorOptions) {
        super(options);

        this.SetHydrated();
    }

    protected onReplacedData(_oldData?: DataEntityBase, _newData?: DataEntityBase) {
        // Do nothing
    }

    protected async doHydrate(_correlation: ICorrelation, _isRehydrate = false) {        
        // Do nothing
    }



}

